import Image from 'next/image';
import { AppNextLink } from '@/features/app-next-link';
import { cn } from '@/utils/cn';
import { getCdnUrl } from '@/utils/url';
type Props = {
  hideInMobile?: boolean;
};
function Logo({
  hideInMobile
}: Props) {
  return <AppNextLink prefetch={false} href='/' className={cn('lg:flex', {
    hidden: hideInMobile
  })} data-sentry-element="AppNextLink" data-sentry-component="Logo" data-sentry-source-file="logo.tsx">
            <Image src={getCdnUrl('/_toad/images/brand/logo.svg?v=1.1')} alt='Khanoumi Logo' width={96} height={48} priority unoptimized className='max-h-6 w-20 lg:h-12 lg:max-h-none lg:w-24 lg:max-w-none' data-sentry-element="Image" data-sentry-source-file="logo.tsx" />
        </AppNextLink>;
}
export default Logo;